<!--
 * @Date: 2020-08-13 09:35:27
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-20 15:20:33
 * @FilePath: \pc-mall\src\views\paySucceed.vue
-->
<template>
  <div class="pay-result">
    <div class="content">
      <p class="text1" v-if="status === 'cancel'">订单已取消</p>
      <p class="text1" v-else>恭喜，支付成功！</p>
      <img src="../assets/images/paysuccess.png" />
      <p class="button">
        <span @click="toHome">返回首页</span>
        <span class="red-btn" @click="toOrder()">查看订单</span>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  created () {
    this.moduleType = this.$route.query.moduleType || 'TRIP'
    this.status = this.$route.query.status || 'success'
  },
  methods: {
    toHome () {
      let homeUrl = '/'
      if (this.moduleType === 'HOTEL') {
        homeUrl = '/hotelList'
      } else if (this.moduleType === 'FOOD') {
        homeUrl = '/foodList'
      } else if (this.moduleType === 'PACKAGES') {
        homeUrl = '/packageTicketList'
      }
      this.$router.push(homeUrl)
    },
    toOrder () {
      this.$router.push({ path: 'personalCenter', query: { moduleType: this.moduleType } })
    }
  }
}
</script>
<style lang="scss" scoped>
.pay-result {
  img{
    margin-top: 65px;
  }
}
</style>
